<template lang="pug">
#producao-agricola-inteligencia-territorial
    .bloco-tabs
        el-tabs.bloco-tabs-dimensao(
            tab-position='left',
            v-model='tabAtiva'
        )
            el-tab-pane(name='1')
                span.bloco-tabs-dimensao-menu(slot='label')
                    i.lyra-icon.lyra-soja
                    | {{ $t('mensagens.inteligenciaTerritorial.imovel.soja') }}
                .bloco-tabs-conteudo
                    GraficoBarrasProducaoAgricola(
                        :dadosAreaPlantada='dadosAreaPlantadaGrafico',
                        :dadosProdutividade='dadosProdutividadeGrafico',
                        :categoriasAreaPlantada='categoriasAreaPlantadaGrafico',
                        :categoriasProdutividade='categoriasProdutividadeGrafico',
                        :textoLegenda="$t('mensagens.inteligenciaTerritorial.imovel.periodo')",
                        :key='idGrafico',
                        :glebas='glebas',
                        :unidadeProdutividade="`(${ $t('mensagens.inteligenciaTerritorial.imovel.sacasHa') })`"
                    )
    .bloco-mapa
        MapaGlebaCar(
            ref='map',
            idMapa='MapaGlebaCar',
            :territorioGeometria='territorioGeometria',
            :mapConfig='configuracoesMapa',
            :showStatesLayers='true',
            :menuMaior='false'
        )
</template>

<script>
import GraficoBarrasProducaoAgricola from '@/components/inteligenciaTerritorial/inteligenciaTerritorialImovel/GraficoBarrasProducaoAgricola.vue';
import MapaGlebaCar from './MapaGlebaCar.vue';

export default {
    name: 'ProducaoAgricola',
    components: {
        GraficoBarrasProducaoAgricola,
        MapaGlebaCar
    },
    props: {
        dadosAreaPlantadaGrafico: {
            type: Array,
            default: () => []
        },
        categoriasAreaPlantadaGrafico: {
            type: Array,
            default: () => []
        },
        dadosProdutividadeGrafico: {
            type: Array,
            default: () => []
        },
        categoriasProdutividadeGrafico: {
            type: Array,
            default: () => []
        },
        territorioGeometria: {
            type: Object,
            default: () => []
        },
        glebas: {
            type: Array,
            default: () => []
        }
    },
    watch: {
        glebas (newValue) {
            this.glebas = newValue;
        }
    },
    data() {
        return {
            idGrafico: 1,
            tabAtiva: '1',
            somatorioDadosGraficos: 0,
            configuracoesMapa: {
                controls: {
                    zoomControl: true,
                    fullscreen: true,
                    camadasControl: true,
                    sentinelHubAccess: true,
                    drawControl: true
                },
                inspecionar: true,
                diagnostico: true
            }
        };
    },
    methods: {
        verificarDados(dados) {
            let somatorio = 0;
            if (!dados) {
                return [{ data: [], name: '' }];
            }
            dados.map(item => {
                item.data.map(valor => {
                    if (!valor) {
                        valor = 0;
                    }
                    somatorio += valor;
                });
            });
            this.somatorioDadosGraficos = somatorio;
            if (somatorio === 0) {
                return [{ data: [], name: '' }];
            } else if (somatorio > 0) {
                return dados;
            }
        }
    }
};
</script>

<style lang="scss">
#producao-agricola-inteligencia-territorial {
    display: flex;
    width: inherit;

    .bloco-tabs {
        width: 50%;
        display: flex;
        order: 0;

        .bloco-tabs-dimensao {
            width: 98%;
            height: 85%;

            .bloco-tabs-conteudo {
                width: 100%;
                background: var(--white);
                height: 845px;
                box-shadow: 0px 0px 20px rgb(0 0 0 / 10%);
                border-radius: 5px;
                padding: 10px 15px;

                h2 {
                    font-size: 16px;
                    color: #3b3b3b;
                    font-weight: 600;
                    margin-bottom: 2px;
                    margin-top: 10px;
                }
            }
            .bloco-tabs-dimensao-menu {
                display: flex;
                flex-direction: column;
                padding-top: 5px;

                i {
                    height: 40px;
                }

                .lyra-icon::before {
                    content: '';
                    width: 31px;
                    height: 38px;
                }
                .balanca-dimensao.lyra-icon::before {
                    content: '';
                    width: 38px !important;
                    height: 41px !important;
                }
            }
        }
        .el-tabs__item {
            text-align: center !important;
            background: var(--white);
            box-shadow: 0px 0px 10px rgb(0 0 0 / 10%);
            border-radius: 5px;
            margin-bottom: 9px;
            font-weight: 600;
            height: 80px;

            .lyra-icon::before {
                background-color: var(--primary);
            }
            i.el-tooltip.mdi.mdi-alert-outline {
                color: var(--primary);
            }

            &.is-active {
                .lyra-icon::before {
                    background-color: var(--white) !important;
                }
                i.el-tooltip.mdi.mdi-alert-outline {
                    color: var(--white) !important;
                }
            }
        }
        .el-tabs__item.is-active {
            color: var(--white) !important;
            background: var(--secondary-two) !important;
        }
        .el-tabs__nav-wrap::after {
            content: '';
            background-color: #e1e1e1 !important;
        }
        .el-tabs__active-bar {
            display: none;
        }
        .el-tabs__content {
            min-height: 730px;
        }
    }
    .bloco-mapa {
        width: 50%;
        height: 718px;
        box-shadow: 0px 1px 5px 0px var(--block-shadow);
        margin-bottom: 14px;
    }
}

#graficoBarrasProducaoAgricola .apexcharts-bar-area:hover {
    fill: #9b7820 !important;
}
#graficoBarrasProducaoAgricola2 .apexcharts-bar-area:hover {
    fill: #9b7820 !important;
}
</style>
